import { render } from "./m-footer.vue?vue&type=template&id=e8d94250"
const script = {}

import "./m-footer.vue?vue&type=style&index=0&id=e8d94250&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__